import { createAsyncThunk } from '@reduxjs/toolkit';
import { AdminApiPaths } from '../../../api/APIPaths';
import APIDataProvider, {
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api/ApiDataProvider';

export interface ICallLog {
  _id: string;
  tutor?: { firstname: string; lastname?: string };
  student?: { firstname: string; lastname?: string };
  course?: { title: string };
  startedAt?: string;
  duration?: number;
  status?: string;
  callId?: string;
}

export type TAdminGetCallLogs = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  tutorId?: string;
  studentId?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
};

const apiDataProvider = new APIDataProvider();

const adminGetCallLogsModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  tutorId,
  studentId,
  status,
  startDate,
  endDate,
}: TAdminGetCallLogs) => {
  let path = `${AdminApiPaths.callLogs}?limit=${limit}&offset=${offset}`;
  if (sortKey) path += `&sortKey=${sortKey}`;
  if (sortValue) path += `&sortValue=${sortValue}`;
  if (tutorId) path += `&tutorId=${tutorId}`;
  if (studentId) path += `&studentId=${studentId}`;
  if (status) path += `&status=${status}`;
  if (startDate) path += `&startDate=${startDate}`;
  if (endDate) path += `&endDate=${endDate}`;
  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<ICallLog>>
  >(path);
  return response.data;
};

export const adminGetCallLogs = createAsyncThunk(
  '/admin/call-logs/list',
  adminGetCallLogsModule
);
